import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=070465cc&scoped=true&"
import script from "./scripts.js?vue&type=script&lang=js&"
export * from "./scripts.js?vue&type=script&lang=js&"
import style0 from "./faq.vue?vue&type=style&index=0&id=070465cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070465cc",
  null
  
)

export default component.exports